module.exports = __webpack_public_path__ + "img/logo_constructor.e1e45fa.svg";